<script setup lang="ts">
interface Props {
  size?: 'sm' | 'md' | 'lg';
}

defineProps<Props>();

// defineEmits<{
//   // 'update:modelValue': [payload: string]
// }>()
</script>

<template>
  <q-chip
    :dense="!$q.screen.gt.sm"
    :class="{
      'text-h6': size === 'lg',
      'text-caption': size === 'sm',
      'text-body': size === 'md',
    }"
  >
    <span class="text-caption text-lowercase">{{ `${$t('SCORE')} ` }}</span>
    <span class="score-value"><slot /></span>
  </q-chip>
</template>

<style scoped>
.score-value {
  display: inline-block;
  min-width: 2.7ch;
  text-align: right;
}
</style>
